import styled from 'styled-components'
import conf from '@configuration'
import {Author} from 'types/rest'
import React from 'react'
import {getLanguage} from '@store/selectors'
import {useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import useMediaQuery from "../../../hooks/useMediaQuery";
import {small} from "../../../constants";

const AuthorView: React.FC<Props> = ({ author }) => {

  const language = useSelector(getLanguage)
  const navigate = useNavigate()
  const isMobile = useMediaQuery(`(max-width: ${small})`)

  return author ? (
    <AuthorsContainer isMobile={isMobile}>
        <AuthorInfoContainer isMobile={isMobile}>
            <Avatar isMobile={isMobile}>
                <img
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null // prevents looping
                        currentTarget.src = 'https://bitsofco.de/content/images/2018/12/broken-1.png'
                    }}
                    style={{ minWidth: '100%', objectFit:'cover',height: '100%' }}
                    src={`${conf.baseUrl}${author.avatar}`}
                    alt=""
                />
            </Avatar>
            <Content>
                <Title isMobile={isMobile} onClick={() => {
                    navigate(`/authors/${author.slug || author.id}`)
                }}>{`${author.name} ${author.surname}`}</Title>
                <Description isMobile={isMobile}>{author.translations[language]}</Description>
            </Content>
        </AuthorInfoContainer>
    </AuthorsContainer>
  ) : (
    <></>
  )}

export default AuthorView

interface Props {
  author: Author
  isMobile?: boolean
  productId: string
}

// region Style
const AuthorsContainer = styled.div<{ isMobile?: boolean }>`
  max-width: 99vw;
  width: 100%;  
  margin: 5rem 0;
`

const Avatar = styled.div<{isMobile: boolean}>`
  aspect-ratio: 1/1;  
  flex-basis: 20%;
${({isMobile})=> isMobile && ' width: 80%;margin: 0 auto;'}
  display: flex;
  justify-content: center;
  align-items:center;
  overflow: hidden;
  border-radius: 50%;
  height:fit-content;
`

const Content = styled.div`
  padding: 1rem;
  flex-basis:70%;
`
const Title = styled.h4<{isMobile?: boolean}>`
  margin: 0;
  font-weight: 700;
  font-size: ${({isMobile}) => isMobile ? 'var(--title-h2-mobile)' : '2.5rem'};
  transition: 0.4s;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
    transition: 0.3s;
  }
`
const Description = styled.p<{isMobile?: boolean}>`
  font-size: ${({isMobile}) => isMobile ? 'var(--parag-body-fs-mobile)' : '1.5rem'};
  font-weight: 300;
`

const AuthorInfoContainer = styled.div<{ isMobile: boolean }>`
  display:flex;
  gap:3rem;   
  ${({isMobile})=> isMobile && 'flex-direction: column;'}
`
// endregion
